import { LatamAgentPage } from '@/screens/Latam/Agents/LatamAgentPage';

export default function AgentDocumentCollectionPage() {
  return (
    <LatamAgentPage locale="es-MX" agentKey="document_collection_and_filing" />
  );
}
